import { z } from "zod";

import { RoomSystemType, RoomSystemVisibility } from "@classview/shared-types";

const createRoomSystemSchema = ({
  isEdit = false,
  isPasswordUpdating = false,
}: {
  isEdit?: boolean;
  isPasswordUpdating?: boolean;
}) => {
  return z.object({
    organisationId: z.string().min(1, { message: "Organisation is required" }),
    name: z.string().min(1, { message: "Name is required" }),
    displayName: z.string().min(1, { message: "Display name is required" }),
    extension: z.string().min(1, { message: "Extension is required" }),
    email: z
      .string({
        required_error: "Email is required",
      })
      .email({ message: "Email is invalid" }),
    password: isEdit
      ? isPasswordUpdating
        ? z.string().min(1, { message: "New password is required" })
        : z.string()
      : z.string().min(1, { message: "Password is required" }),
    type: z.nativeEnum(RoomSystemType, {
      errorMap: () => ({ message: "Room system type is required" }),
    }),
    visibility: z.nativeEnum(RoomSystemVisibility, {
      errorMap: () => ({ message: "Room system visibility is required" }),
    }),
  });
};

type RoomSystemFormData = z.infer<ReturnType<typeof createRoomSystemSchema>>;

export { createRoomSystemSchema };
export type { RoomSystemFormData };
